import React, { useEffect, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { translate } from '@utils/i18n';
import useGetTerritories from '@hooks/requests/territories.get.hook';
import { TerritorySelect } from './TerritorySelect';
const NAMESPACE = 'features.modals.territory_select';
export function TerritoryField({ preselectWhenEmpty = false, onChange = undefined }) {
    var _a;
    const { control, setValue, getValues, formState } = useFormContext();
    const { territories, restricted, loading, error } = useGetTerritories();
    const preselected = useRef(false);
    const arrivedCompanyWide = (((_a = formState.defaultValues) === null || _a === void 0 ? void 0 : _a.territoryIds) || []).length === 0;
    const companyWideLocked = restricted && !preselectWhenEmpty && arrivedCompanyWide;
    useEffect(() => {
        if (!preselectWhenEmpty || preselected.current || loading || !restricted)
            return;
        if (getValues('territoryIds').length > 0)
            return;
        preselected.current = true;
        setValue('territoryIds', territories.map((territory) => territory.id));
    }, [preselectWhenEmpty, loading, restricted, territories, setValue, getValues]);
    if (loading)
        return null;
    const loadFailedMessage = error ? translate('load_failed', { namespace: NAMESPACE }) : undefined;
    return (React.createElement(Controller, { name: "territoryIds", control: control, rules: {
            validate: (value) => {
                if (preselectWhenEmpty && loadFailedMessage)
                    return loadFailedMessage;
                if (!restricted || companyWideLocked)
                    return true;
                const own = (value || []).filter((id) => territories.some((territory) => territory.id === id));
                return own.length > 0 || translate('required_restricted', { namespace: NAMESPACE });
            }
        }, render: ({ field, fieldState }) => {
            var _a;
            return (React.createElement(TerritorySelect, { options: territories.map((territory) => ({ label: territory.name, value: territory.id })), restricted: restricted, disabled: !!error || companyWideLocked, lockedReason: companyWideLocked ? translate('company_wide_locked', { namespace: NAMESPACE }) : undefined, values: field.value || [], onChange: (values) => {
                    const current = field.value || [];
                    const hidden = current.filter((id) => !territories.some((territory) => territory.id === id));
                    const assigned = [...hidden, ...values];
                    if (onChange) {
                        void onChange(field, assigned);
                    }
                    else {
                        field.onChange(assigned);
                    }
                }, error: ((_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message) || loadFailedMessage }));
        } }));
}
export default TerritoryField;
